// Google Analytics 4 helpers

const GA_ID = 'G-89T7DPP7V3';

let initialized = false;

export function initGA() {
  if (initialized || !GA_ID) return;
  initialized = true;

  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());
  // SAB-706: disable Google Signals + ads personalization in code, so the
  // "no ad personalization / no cross-device ad tracking" claim holds regardless
  // of the GA4 property's dashboard setting. GA4 stays first-party product
  // analytics only (no IDFA, no ad SDK — confirmed not linked in the iOS binary).
  window.gtag('config', GA_ID, {
    send_page_view: true,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
}

/** Send a page_view event for SPA navigation */
export function trackPageView(path: string) {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
  });
}

/** Send a custom GA4 event */
export function trackEvent(name: string, params?: Record<string, string | number | boolean>) {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', name, params);
}

// Extend Window for TypeScript
declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}
